<script lang="ts" setup>
import { computed } from 'vue';
import { ServerProvisioningState } from 'gpcore-grpc/gpcore/api/cloud/v1/server_pb';
import type { Node } from 'gpcore-grpc/gpcore/api/cloud/v1/node_pb';
import { GpTooltip } from '@gportal/uikit';
import Status from './Component.Status.vue';

const props = defineProps<{
  node: Node;
}>();

const status = computed(() => {
  if (props.node) {
    return props.node.status;
  }
  return ServerProvisioningState.UNSPECIFIED;
});
</script>

<template>
  <GpTooltip
    v-if="
      status === ServerProvisioningState.DEPLOYING || status === ServerProvisioningState.DEPLOY_WAIT
    "
    placement="top"
    content="The node is currently performing a installation."
  >
    <Status state="info" label="Deploying" loading />
  </GpTooltip>
  <GpTooltip
    v-else-if="
      status === ServerProvisioningState.CLEANING || status === ServerProvisioningState.DELETING
    "
    placement="top"
    content="The node is currently cleaning it's old installation."
  >
    <Status state="warning" label="Cleaning" loading />
  </GpTooltip>
  <GpTooltip
    v-else-if="
      status === ServerProvisioningState.ACTIVE || status === ServerProvisioningState.AVAILABLE
    "
    placement="top"
    content="The node is installed."
  >
    <Status state="success" label="Online" />
  </GpTooltip>
  <Status
    v-else-if="
      status === ServerProvisioningState.RESCUE ||
      status === ServerProvisioningState.RESCUING ||
      status === ServerProvisioningState.UNRESCUING
    "
    state="warning"
    label="Rescue Mode"
  />

  <Status
    v-else-if="status === ServerProvisioningState.UNSPECIFIED"
    state="none"
    label="Unspecified"
  />

  <Status v-else :label="Object.keys(ServerProvisioningState)[status]" />
</template>
